<template>
  <div>
    <ed-modal
      :title="formData.id == 0 ? 'Nova Conta WhatsApp' : 'Editar Conta WhatsApp'"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :onSave="salvar"
      width="80%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <el-form label-position="top">
          <div class="row">
            <!-- Nome -->
            <div class="col-12">
              <el-form-item>
                <span slot="label" style="color: #636363">
                  <label>Nome da Conta</label>
                  <el-tooltip effect="dark" placement="top" content="Nome identificador para esta conta de WhatsApp">
                    <a href="#"><i class="fa fa-question-circle" aria-hidden="true"></i></a>
                  </el-tooltip>
                </span>
                <el-input v-model="formData.nome" maxlength="500" show-word-limit autocomplete="false" />
              </el-form-item>
            </div>

            <!-- Phone Number ID -->
            <div class="col-md-6">
              <el-form-item>
                <span slot="label" style="color: #636363">
                  <label>Phone Number ID</label>
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content" style="max-width: 350px;">
                      ID do número de telefone na Meta.<br>
                      Encontre em: Meta Business Suite > WhatsApp > Configurações da API
                    </div>
                    <a href="#"><i class="fa fa-question-circle" aria-hidden="true"></i></a>
                  </el-tooltip>
                </span>
                <el-input v-model="formData.phone_number_id" maxlength="255" autocomplete="false" />
              </el-form-item>
            </div>

            <!-- Business Account ID -->
            <div class="col-md-6">
              <el-form-item>
                <span slot="label" style="color: #636363">
                  <label>Business Account ID</label>
                  <el-tooltip effect="dark" placement="top" content="ID da conta WhatsApp Business na Meta">
                    <a href="#"><i class="fa fa-question-circle" aria-hidden="true"></i></a>
                  </el-tooltip>
                </span>
                <el-input v-model="formData.business_account_id" maxlength="255" autocomplete="false" />
              </el-form-item>
            </div>

            <!-- Access Token -->
            <div class="col-12">
              <el-form-item>
                <span slot="label" style="color: #636363">
                  <label>Access Token</label>
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content" style="max-width: 350px;">
                      Token de acesso permanente da Meta.<br>
                      Gere em: Meta Business Suite > WhatsApp > Configurações da API > Token de acesso permanente
                    </div>
                    <a href="#"><i class="fa fa-question-circle" aria-hidden="true"></i></a>
                  </el-tooltip>
                </span>
                <el-input
                  v-model="formData.access_token"
                  :type="showAccessToken ? 'text' : 'password'"
                  autocomplete="false"
                >
                  <el-button
                    slot="append"
                    @click="showAccessToken = !showAccessToken"
                    :title="showAccessToken ? 'Ocultar token' : 'Mostrar token'"
                  >
                    <i :class="showAccessToken ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from 'common/rest';
import EdModal from 'common/modal';

export default {
  name: 'conta-whatsapp-editar',
  components: { EdModal },
  mixins: [Rest],
  props: {
    parent: { type: Object, default: null },
    showForm: { type: Boolean, default: false }
  },
  watch: {
    showForm(val) {
      this.showFormEdit = val;
      if (val) this.init();
    }
  },
  data() {
    return {
      config: {
        loading: {
          save: false,
          content: false
        }
      },
      formData: {
        id: 0,
        nome: null,
        phone_number_id: null,
        business_account_id: null,
        access_token: null
      },
      response: {},
      showFormEdit: false,
      showAccessToken: false
    };
  },
  methods: {
    init() {
      this.response = {};
      this.showAccessToken = false;

      if (!this.parent || !this.parent.formData) return;

      this.formData = {
        id: this.parent.formData.id || 0,
        nome: this.parent.formData.nome || null,
        phone_number_id: this.parent.formData.phone_number_id || null,
        business_account_id: this.parent.formData.business_account_id || null,
        access_token: null
      };
    },

    salvar() {
      this.response = {};
      this.config.loading.save = true;

      if (!this.validarFormulario()) {
        this.config.loading.save = false;
        return;
      }

      this.post('conta-whatsapp/editar', this.formData).then((result) => {
        result = result[0];
        this.config.loading.save = false;
        this.response = result;

        if (result.status == 200) {
          this.edMsg('Registro salvo com sucesso!');
          this.showFormEdit = false;

          if (this.parent && this.parent.getContaWhatsapp) {
            this.parent.getContaWhatsapp();
          }
        }
      }).catch(() => {
        this.config.loading.save = false;
      });
    },

    validarFormulario() {
      if (!this.formData.nome) {
        this.edMsg('Nome é obrigatório', 'error');
        return false;
      }
      if (!this.formData.phone_number_id) {
        this.edMsg('Phone Number ID é obrigatório', 'error');
        return false;
      }
      if (!this.formData.business_account_id) {
        this.edMsg('Business Account ID é obrigatório', 'error');
        return false;
      }
      if (!this.formData.access_token && this.formData.id === 0) {
        this.edMsg('Access Token é obrigatório', 'error');
        return false;
      }
      return true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// editar.vue?05a53d36